<template>
  <div>
    <div v-if="success" >
      <slot />
    </div>
    <div v-else >
      <div v-if="hasError" >
        <p
          v-for="error in errors"
          :key="error"
          class="text-error font-bold text-sm"
        >{{ error }}</p>
      </div>
      <div class="w-full" >
        <form class="grid md:grid-cols-2 pt-2 lg:pt-4 gap-4 p-4 md:p-8" >

          <div>
            <label for="first-name" class="sr-only">First Name</label>
            <input
              v-model="formData.fname"
              id="first-name"
              type="text"
              class="px-4 py-2 text-sm w-full rounded-xs overflow-hidden border"
              :class="{ 'border-error': hasError && formData.fname == '' }"
              placeholder="First Name"
              required
            >
          </div>

          <div>
            <label for="last-name" class="sr-only">Last Name</label>
            <input
              v-model="formData.lname"
              id="last-name"
              type="text"
              class="px-4 py-2 text-sm w-full rounded-xs overflow-hidden border"
              :class="{ 'border-error': hasError && formData.lname == '' }"
              placeholder="Last Name"
              required
            >
          </div>

          <div>
            <label for="email-address" class="sr-only">Email Address</label>
            <input
              v-model="formData.email"
              id="email-address"
              type="email"
              class="px-4 py-2 text-sm w-full rounded-xs overflow-hidden border"
              :class="{ 'border-error': hasError && formData.email == '' }"
              placeholder="Email Address"
              required
            >
          </div>

          <div>
            <label for="phone-number" class="sr-only">Phone Number</label>
            <input
              v-model="formData.phone"
              id="phone-number"
              type="tel"
              class="px-4 py-2 text-sm w-full rounded-xs overflow-hidden border"
              :class="{ 'border-error': hasError && formData.phone == '' }"
              placeholder="Phone Number"
              required
            >
          </div>

          <div class="md:col-span-2">
            <label for="message" class="sr-only">Message</label>
            <textarea
              type="text"
              id="message"
              v-model="formData.message"
              class="px-4 py-2 text-sm w-full h-24 md:h-32 rounded-xs overflow-hidden group border" :class="{ 'border-error': hasError && formData.message == '' }"
              placeholder="Type your message here."
              required
            />
          </div>

          <div class="md:col-span-2 h-0 w-0 overflow-hidden" >
            <label for="terms" class="opacity-0 absolute z-0 -left-[9999px]" >
              <input type="checkbox" v-model="formData.terms" id="terms" name="terms" tabindex="-1" />
              I agree to the <a href="/privacy-policy/" target="_blank" tabindex="-1" >Terms & Conditions</a>
            </label>
          </div>

          <div class="md:col-span-2 flex flex-col xl:flex-row items-center pt-2" >
            <button
              @click.prevent="submitForm"
              type="submit"
              :disabled="processing"
              class="btn-accent-outlined py-2 px-4 md:px-6"
            >
              Send Message
            </button>
            <div
              v-if="!processing"
              class="text-sm p-4 leading-none"
              :class="{ 'text-error font-bold': this.hasError }" >
              All fields required</div>
            <div
              v-if="processing"
              class="text-sm p-4 leading-none"
              >Sending&nbsp;inquiry.</div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ContactForm',
  props: {
    nonce: {
      type: String,
      default: '',
    },
    userIp: {
      type: String,
      default: '',
    },
    userAgent: {
      type: String,
      default: '',
    },
    referrer: {
      type: String,
      default: '',
    },
    form: {
      type: String,
      default: 'Contact Form'
    },
    to: {
      type: String,
      default: ''
    },
    source: {
      type: Object,
      default: () => {}
    },
  },

  data () {
    return {
      processing: false,
      errors: {},
      errorCode: null,
      success: false,
      hasError: false,
      formData: {
        fname: '',
        lname: '',
        phone: '',
        email: '',
        message: '',
        terms: false,
      },
      mailto: '',
      submitted: false,
    }
  },

  computed: {
    validate() {
      return this.formData.fname != '' &&
        this.formData.lname != '' &&
        this.formData.phone != '' &&
        this.formData.email != '' &&
        this.formData.message != ''
    },
  },

  mounted () {
    this.formData.post_id = this.postId
    this.formData.user_ip = this.userIp
    this.formData.user_agent = this.userAgent
    this.formData.referrer = this.referrer
  },

  methods: {
    submitForm () {
      this.processing = true

      fetch('/wp-json/kma/v1/submit-contact-form', {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          'X-WP-Nonce': this.nonce
        },
        body: JSON.stringify(this.formData)
      })
        .then(r => r.json())
        .then((res) => {

          if(res.data == 'submitted') {
            this.success = true
          }

          if(res.data == 'success'){
            this.success = true

            dataLayer.push({
              'event': 'form_submitted',
              'form_name': 'Contact Form',
              'form_type': this.source.post_type,
              'form_source': this.source.post_title
            })

            // Google Ads conversion code
            // gtag('event', 'conversion', {'send_to': ''});

            // Facebook conversion code
            // fbq('track', 'Lead');
          }

          if(res.success == false ){
            this.success  = false
            this.hasError = true
            this.errors   = res.data
          }

          this.processing   = false

        })
    },

  }
}
</script>
